import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import Header_3 from '../headers/Header_3';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import Button from '../components/Button';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import SEO from '../components/Seo';
import ThemenModule from '../modules/ThemenModule';
import QuoteModule from '../modules/QuoteModule';

export const Jobs = () => {
    const [show, setShow] = useState(false);
    const [activeTab, setActiveTab] = useState("tab1");


    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/jobs-page?populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Video][populate]=*&populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate]=*&populate[Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Modul][on][modules.bilder-und-videos][populate][Bilder][populate]=*&populate[Modul][on][modules.bilder-und-videos][populate][Video][populate]=*&populate[Modul][on][modules.bilder-und-videos][populate][Videominiaturansicht][populate]=*&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Bild]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Video]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Videominiatur]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][PDF][populate][PDF]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Button]=true&populate[Modul][on][modules.quote][populate]=*&populate[Metadaten]=*");


            // &populate[Modul][on][modules.bilder-und-videos][populate][Video][populate]=*&populate[Modul][on][modules.bilder-und-videos][populate][Videominiaturansicht][populate]=*


            // &populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Bild]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][PDF][populate][PDF]=true


            // &populate[Modul][on][modules.bilder-und-videos][populate][Bilder_und_Videos][populate]=*
            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][siedlungen_kategorien][populate]=*

            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data.data?.Metadaten);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    const videoRef = useRef(null);
    const [play, setPlay] = useState(false);

    const playVideo = () => {
        setPlay(true);
    }

    const pauseVideo = () => {
        setPlay(false);
    }

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hovering, setHovering] = useState(false);

    const mouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        setPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-3-titel-text-bild" && (
                            <Header_3 module={module} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-genossenschaft" activePage="genossenschaft" />
                        )}
                    </React.Fragment>
                ))
            )}


            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-pink-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <div className='subtitle'><img src='https://backend.bgzurlinden.ch/uploads/logo_icon_981b559742.svg' alt='#' /> zurlinden</div> */}
                                    {/* <div className='page-breadcrumb pb-5'>
                                        <Breadcrumbs />
                                    </div> */}
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="pink" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} highlight={false} />
                        }
                        {module.__component === "modules.bilder-und-videos" &&
                            <section className={`pt-pb-10 sec-pink-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {module?.Bild_oder_Video === "Video" ? (

                                        <div className={`video_thumbnail position-relative ${hovering && play ? 'hide_cursor' : ''}`} onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)} onMouseMove={mouseMove}>

                                            {play && <video
                                                ref={videoRef}
                                                className="w-100 d-block pb-0"
                                                // controls
                                                autoPlay
                                                playsInline
                                                preload="metadata"
                                                onClick={pauseVideo}
                                                onEnded={pauseVideo}
                                                style={{ aspectRatio: module?.quadratisches_Bild ? '1/1' : '1620/810.5' }}
                                            >
                                                <source
                                                    src={`https://backend.bgzurlinden.ch${module?.Video?.url}`}
                                                    type="video/mp4"
                                                />
                                            </video>}

                                            {hovering && play && (
                                                <div
                                                    className="video_image_cursor"
                                                    style={{
                                                        left: `${position.x}px`,
                                                        top: `${position.y}px`,
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                                        <path d="M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60Z" fill={`var(--pink)`} fill-opacity="1" />
                                                        <rect x="47" y="38" width="8" height="45" fill="white" />
                                                        <rect x="66" y="38" width="8" height="45" fill="white" />
                                                    </svg>
                                                </div>
                                            )}

                                            {!play && (
                                                <>
                                                    <img
                                                        src={`https://backend.bgzurlinden.ch${module?.Videominiaturansicht?.url}`}
                                                        alt=''
                                                        className='video_overlay_img'
                                                        style={{ aspectRatio: module?.quadratisches_Bild ? '1/1' : '1620/810.5' }}
                                                    />

                                                    <button
                                                        type='button'
                                                        onClick={playVideo}
                                                        className='video_play_btn'
                                                    >
                                                        <svg className='icon_play' xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
                                                            <circle cx="60" cy="60" r="60" fill={`var(--pink)`} />
                                                            <path d="M83 60L43 83L43 37L83 60Z" fill="white" />
                                                        </svg>
                                                    </button>
                                                </>
                                            )}

                                        </div>
                                    ) : (
                                        <img src={`https://backend.bgzurlinden.ch${module?.Bild_oder_Video === "Video" ? module?.Videominiaturansicht?.url : module?.Bilder[0]?.url}`} alt='#' />
                                    )}
                                </div>
                            </section>
                        }
                        {module.__component === "modules.benefits" &&
                            <section className='pb-10 sec-bg-grey sec-pink-color'>
                                <div className='container'>
                                    <div className='row default-grid-gap job-card-row tabs-content'>
                                        {module?.Benefits_Data?.map((item, index) => (
                                            <div key={index} className='col-6 col-md-4 col-lg-3 col-item mt-4'>
                                                <div className="flip-card text-center position-relative">
                                                    <div className="flip-card-front">
                                                        <img src={`https://backend.bgzurlinden.ch${item.Icon?.url}`} alt={item?.Titel} />
                                                        <h4 lang='de' className='text-darkgrey fw-550 fs_24'>{item?.Titel}</h4>
                                                    </div>
                                                    <div className="flip-card-back">
                                                        <p lang="de">{item?.Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>
                        }
                        {module.__component === "modules.themenmodul-komplett" &&
                            <ThemenModule module={module} />
                        }
                        {module.__component === "modules.quote" &&
                            <section className={`pt-pb-10 sec-pink-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <QuoteModule data={module?.Quote} titleColor="pink" />
                                </div>
                            </section>
                        }

                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}

        </div>
    )
}